import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";

const links = [
  { label: "The Book", href: "#hero" },
  { label: "Journey", href: "#journey" },
  { label: "Author", href: "#author" },
  { label: "FAQ", href: "#faq" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-black/70 backdrop-blur-xl border-b border-white/5"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
        <a
          href="#hero"
          data-testid="nav-logo"
          className="flex items-center gap-2 group"
        >
          <span className="font-serif-display text-2xl tracking-tight text-white">
            30<span className="gold-text">DG</span>
          </span>
          <span className="hidden sm:inline text-[11px] uppercase tracking-[0.3em] text-neutral-500 group-hover:text-[#d4af37] transition-colors">
            Kendrick Callicutt
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-sm text-neutral-400 hover:text-[#e5c158] transition-colors relative group"
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 w-0 h-px bg-[#d4af37] transition-all duration-300 group-hover:w-full" />
            </a>
          ))}
        </nav>

        <Button
          asChild
          data-testid="nav-cta-buy"
          className="bg-[#d4af37] text-black hover:bg-[#e5c158] rounded-full px-5 h-9 text-sm font-medium shadow-[0_0_30px_rgba(212,175,55,0.18)]"
        >
          <a
            href="https://kcuttstudios.gumroad.com/l/ijgso"
            target="_blank"
            rel="noopener noreferrer"
          >
            Get the ebook — $16.99
          </a>
        </Button>
      </div>
    </header>
  );
}
